export default __webpack_public_path__ + "static/media/hpe-bg.a2215fbe.jpg";